var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.411 3.74397H12.4016V2.00649C12.4016 1.45165 11.9499 1 11.3941 1H6.14332C5.588 1 5.13635 1.45165 5.13635 2.00649V3.74397H2.00649C1.45165 3.74397 1 4.19562 1 4.75094V5.76174C1 6.31707 1.45165 6.76919 2.00649 6.76919H2.40054L2.79843 18.6671C2.79843 19.2483 3.27072 19.7206 3.85196 19.7206H13.566C14.1472 19.7206 14.6195 19.2483 14.619 18.6829L15.0169 6.76919H15.4105C15.9663 6.76919 16.4184 6.31707 16.4184 5.76174V4.75094C16.4189 4.19562 15.9668 3.74397 15.411 3.74397ZM13.6596 18.6676C13.6596 18.7199 13.6183 18.7612 13.566 18.7612H3.85196C3.79964 18.7612 3.75837 18.7199 3.75837 18.6512L3.36143 6.76919H14.057L13.6596 18.6676ZM15.459 5.76222C15.459 5.78766 15.4364 5.80974 15.411 5.80974H14.5533H2.86467H2.00601C1.98057 5.80974 1.95945 5.78814 1.95945 5.76222V4.75142C1.95945 4.7255 1.98009 4.70438 2.00601 4.70438H5.61583C5.88078 4.70438 6.0958 4.48935 6.0958 4.22441V2.00697C6.0958 1.98105 6.11692 1.96041 6.14284 1.96041H11.3941C11.4205 1.96041 11.4417 1.98105 11.4417 2.00697V4.22441C11.4417 4.48935 11.6562 4.70438 11.9216 4.70438H15.411C15.4369 4.70438 15.459 4.72598 15.459 4.75142V5.76222Z",
    fill: "#C20000",
    stroke: "#C20000",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trashIcon.67990698307543b2b4e41407b85cf889.svg";
export { ForwardRef as ReactComponent };